(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mg-add-to-cart-badge"] && !Shopify.designMode) return;
  try {
    (() => {
    const badge = document.querySelector('[data-mg-atc-badge]');
    if (!badge) return;

    const mediaQuery = window.matchMedia('(max-width: 749px)');
    const pandectesHideStyleId = 'mg-atc-badge-hide-pandectes';
    const pandectesHideCss = '.widget.bottom.left.shadow-dialog { display: none !important; }';
    let atcAboveViewport = false;
    let footerInView = false;

    const setPandectesWidgetHidden = (hidden) => {
      document.querySelectorAll('pandectes-cmp').forEach((cmp) => {
        const root = cmp.shadowRoot;
        if (!root) return;

        let style = root.getElementById(pandectesHideStyleId);
        if (hidden) {
          if (!style) {
            style = document.createElement('style');
            style.id = pandectesHideStyleId;
            style.textContent = pandectesHideCss;
            root.appendChild(style);
          }
        } else if (style) {
          style.remove();
        }

        const widget = root.querySelector('.widget.bottom.left.shadow-dialog');
        if (!widget) return;

        if (hidden) {
          widget.style.setProperty('display', 'none', 'important');
        } else {
          widget.style.removeProperty('display');
        }
      });
    };

    const updateVisibility = () => {
      const shouldShow = mediaQuery.matches && atcAboveViewport && !footerInView;
      badge.classList.toggle('is-visible', shouldShow);
      badge.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      setPandectesWidgetHidden(shouldShow);
    };

    const trigger = [...document.querySelectorAll('add-to-cart-component')].find((el) => !badge.contains(el));
    const footer = document.querySelector('footer');

    if (trigger) {
      new IntersectionObserver(([entry]) => {
        // Show only when the main ATC has scrolled out above the viewport
        // (user is below the button). Hide when it's in view or still below.
        atcAboveViewport = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        updateVisibility();
      }).observe(trigger);
    }

    if (footer) {
      new IntersectionObserver(([entry]) => {
        footerInView = entry.isIntersecting;
        updateVisibility();
      }).observe(footer);
    }

    mediaQuery.addEventListener('change', updateVisibility);

    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.matches?.('pandectes-cmp') || node.querySelector?.('pandectes-cmp')) {
            setPandectesWidgetHidden(badge.classList.contains('is-visible'));
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mg-breadcrumbs-blog"] && !Shopify.designMode) return;
  try {
    const el = document.querySelector('.breadcrumbs-list');
  if (el && el.scrollWidth > el.clientWidth) {
    el.scrollTo({
      left: el.scrollWidth,
      behavior: 'smooth',
    });
  }
  } catch(e) { console.error(e); }
})();

})();
